import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import {
  Box,
  FormControlLabel,
  Grid,
  MenuItem,
  Radio,
  TextField,
} from '@material-ui/core'
import { KeyboardDatePicker } from '@material-ui/pickers'
import moment from 'moment'

import { ControlledRadioGroup } from './components'
import constants from 'constants/index'

const ExpirationPickerComponent = () => {
  const { control, watch, errors } = useFormContext()

  const formExpirationChoice = parseInt(watch('expirationType'))

  return (
    <Grid item xs={12}>
      <Controller
        as={
          <ControlledRadioGroup>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <FormControlLabel
                  value={0}
                  control={<Radio size="small" />}
                  label="Por data de expiração do formulário"
                />
              </Grid>

              {formExpirationChoice === 0 && (
                <Grid item xs={12}>
                  <Controller
                    as={
                      <KeyboardDatePicker
                        fullWidth
                        format="DD/MM/yyyy"
                        label="Escolha a data de vencimento"
                        inputVariant="outlined"
                        error={!!errors?.dueDateValue}
                        helperText={errors?.dueDateValue?.message}
                        disablePast
                        shouldDisableDate={(date) => {
                          return moment(date).isSameOrBefore(moment(), 'day')
                        }}
                        clearable
                      />
                    }
                    control={control}
                    onChange={([date]) => date}
                    name="dueDateValue"
                    mode="onBlur"
                  />
                </Grid>
              )}
            </Grid>

            <Box mt={2}>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <FormControlLabel
                    value={1}
                    control={<Radio size="small" />}
                    label="Por tempo de expiração de assinatura"
                  />
                </Grid>

                {formExpirationChoice === 1 && (
                  <Grid container spacing={1}>
                    <Grid item xs={6}>
                      <Controller
                        as={
                          <TextField
                            error={!!errors?.expirationTime}
                            helperText={errors?.expirationTime?.message}
                            label="Escolha o tempo de validade"
                            variant="outlined"
                            fullWidth
                            type="number"
                            inputProps={{ min: 1, step: 1 }}
                          />
                        }
                        control={control}
                        name="expirationTime"
                        mode="onBlur"
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <Controller
                        as={
                          <TextField
                            select
                            label="Escolha a unidade do tempo de validade"
                            fullWidth
                            error={!!errors?.expirationUnit}
                            helperText={errors?.expirationUnit?.message}
                          >
                            <MenuItem value={constants.documents.DAY_UNIT}>
                              Dias
                            </MenuItem>
                            <MenuItem value={constants.documents.MONTH_UNIT}>
                              Meses
                            </MenuItem>
                            <MenuItem value={constants.documents.YEAR_UNIT}>
                              Anos
                            </MenuItem>
                          </TextField>
                        }
                        control={control}
                        name="expirationUnit"
                        mode="onBlur"
                      />
                    </Grid>
                  </Grid>
                )}
              </Grid>
            </Box>
          </ControlledRadioGroup>
        }
        control={control}
        name="expirationType"
        mode="onBlur"
      />
    </Grid>
  )
}

export default ExpirationPickerComponent
